import { Link } from 'react-router-dom';
import { newMovies, movies } from '@/mocks/movies';

const allMovies = [...newMovies, ...movies.filter(m => !m.isNew)].slice(0, 8);

export default function LatestUpdate() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50" aria-label="最新更新" data-product-shop="">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
              <i className="ri-timer-flash-line text-primary-500 mr-2"></i>
              最新更新
            </h2>
            <p className="mt-1 text-sm text-foreground-500">不错过任何精彩，实时更新热门资源</p>
          </div>
          <Link
            to="/category/movie?sort=new"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            更多更新
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {allMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group flex gap-3 p-3 bg-background-50 border border-background-200/70 rounded-xl hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-20 h-28 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={movie.coverImage}
                  alt={movie.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col justify-between min-w-0 flex-1">
                <div>
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {movie.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{movie.description}</p>
                </div>
                <div className="flex items-center gap-2 mt-2">
                  <span className="px-1.5 py-0.5 text-[10px] bg-accent-100 text-accent-700 rounded font-medium">
                    {movie.rating}分
                  </span>
                  <span className="text-[10px] text-foreground-400">{movie.updateInfo}</span>
                  {movie.isNew && (
                    <span className="px-1.5 py-0.5 text-[10px] bg-primary-100 text-primary-600 rounded font-medium">
                      新
                    </span>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}